import { Confirmation } from 'src/app/shared/components/confirmation-modal/confirmation';
import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ManageParameterListComponent } from 'src/app/features/admin/parameters-list/manage-parameter-list/manage-parameter-list.component';
import { Reporte } from 'src/app/features/data-visualization/reports/models/reporte';
import { ReportDataComponent } from 'src/app/features/data-visualization/reports/report-data/report-data.component';
import { ReportParametersComponent } from 'src/app/features/data-visualization/reports/report-parameters/report-parameters.component';
import { ConfirmationModalComponent } from '../components/confirmation-modal/confirmation-modal.component';
import { TareaReporte } from 'src/app/features/tasks/tarea-reporte';
import { ManageUserComponent } from 'src/app/features/user/manage-user/manage-user.component';
import { User } from 'src/app/features/user/user';
import { ParametroLista } from 'src/app/features/data-visualization/reports/models/parametro';
import { ReportGroup } from 'src/app/features/admin/report-group/report-group';
import { ManageReportGroupComponent } from 'src/app/features/admin/report-group/manage-report-group/manage-report-group.component';
import { ResetPasswordComponent } from 'src/app/auth/reset-password/reset-password.component';
import { ChangePasswordComponent } from 'src/app/features/user/edit-profile/change-password/change-password.component';
import { ReportGroupToUserComponent } from 'src/app/features/user/report-group-to-user/report-group-to-user.component';
import { ReportListComponent } from 'src/app/features/admin/report-group/report-list/report-list.component';

@Injectable({
    providedIn: 'root'
})
export class ModalService {

    constructor(private modalService: NgbModal) { }

    public open(content: any, options?: NgbModalOptions): NgbModalRef {
        return this.modalService.open(content, options);
    }

    public getResetPasswordModal(options?: NgbModalOptions) {
        const ngbModalRef: NgbModalRef = this.modalService
            .open(ResetPasswordComponent, options || { backdrop: 'static', size: 'md', keyboard: false, centered: true });
        return ngbModalRef;
    }
    public getChangePasswordModal(options?: NgbModalOptions) {
        const ngbModalRef: NgbModalRef = this.modalService
            .open(ChangePasswordComponent, options || { backdrop: 'static', size: 'md', keyboard: false, centered: true });
        return ngbModalRef;
    }

    public getConfirmacionModal(confirmation: Confirmation, options?: NgbModalOptions) {
        const ngbModalRef: NgbModalRef = this.modalService
            .open(ConfirmationModalComponent, options || { backdrop: 'static', size: 'md', keyboard: false, centered: true });
        (ngbModalRef.componentInstance as ConfirmationModalComponent).body = confirmation;
        return ngbModalRef;
    }

    public getReportParametersModal(report: Reporte, options?: NgbModalOptions) {
        const ngbModalRef: NgbModalRef = this.modalService
            .open(ReportParametersComponent, options || { centered: true, size: 'lg' });
        (ngbModalRef.componentInstance as ReportParametersComponent).report = report;
        return ngbModalRef;
    }

    public getReportTaskDataModal(reportTask: TareaReporte, options?: NgbModalOptions) {
        const ngbModalRef: NgbModalRef = this.modalService
            .open(ReportDataComponent, options || { centered: true, size: 'xl' });
        (ngbModalRef.componentInstance as ReportDataComponent).reportTask = reportTask;
        return ngbModalRef;
    }

    public getManageParameterListModal(parameterList?: ParametroLista, options?: NgbModalOptions) {
        const ngbModalRef: NgbModalRef = this.modalService
            .open(ManageParameterListComponent, options || { centered: true, size: 'lg' });
        if (parameterList)
            (ngbModalRef.componentInstance as ManageParameterListComponent).parameterList = parameterList;
        return ngbModalRef;
    }

    public getManageUserModal(user?: User, options?: NgbModalOptions) {
        const ngbModalRef: NgbModalRef = this.modalService
            .open(ManageUserComponent, options || { centered: true, size: 'lg' });
        if (user)
            (ngbModalRef.componentInstance as ManageUserComponent).user = user;
        return ngbModalRef;
    }

    public getConfigUserModal(user: User, options?: NgbModalOptions) {
        const ngbModalRef: NgbModalRef = this.modalService
            .open(ReportGroupToUserComponent, options || { centered: true, size: 'lg' });
        (ngbModalRef.componentInstance as ReportGroupToUserComponent).currentUser = user;
        return ngbModalRef;
    }

    public getManageReportGroupModal(reportGroup?: ReportGroup, options?: NgbModalOptions) {
        const ngbModalRef: NgbModalRef = this.modalService
            .open(ManageReportGroupComponent, options || { centered: true, size: 'lg' });
        if (reportGroup)
            (ngbModalRef.componentInstance as ManageReportGroupComponent).reportGroup = reportGroup;
        return ngbModalRef;
    }

    public getReportListModal(reportGroup?: ReportGroup, options?: NgbModalOptions) {
        const ngbModalRef: NgbModalRef = this.modalService
            .open(ReportListComponent, options || { centered: true, size: 'xl' });
        if (reportGroup)
            (ngbModalRef.componentInstance as ReportListComponent).reportGroup = reportGroup;
        return ngbModalRef;
    }

    hasOpenModals = (): boolean => this.modalService.hasOpenModals();

    dismissAll() {
        this.modalService.dismissAll();
    }
}